import { createBrowserRouter } from 'react-router';
import { routeObject } from './constants/routeObject.constant';

const router = () => createBrowserRouter(routeObject());

export { router };
